import React from 'react';
import PropTypes from 'prop-types';

import { ButtonText, SvgIcon, Text } from 'Components/Base';

const getTextColor = (value) => {
  if (value === 3 || value === 4) return 'success';
  if (value === 1 || value === 2) return 'danger';
  return 'greyscale.grey3';
};

const AttachmentOptionButton = ({ option, isSelected, onClickOption }) => {
  const color = isSelected ? getTextColor(option.value) : 'greyscale.grey3';

  return (
    <ButtonText
      key={option.value}
      onClick={() => onClickOption(option.value)}
      style={{
        padding: 12,
        width: 60,
        minWidth: 60,
        boxSizing: 'content-box',
      }}
      color={color}
    >
      <SvgIcon icon={option.icon} size={40} color={color} />
      <Text textStyle="caption" mt={1}>
        {option.label}
      </Text>
    </ButtonText>
  );
};

AttachmentOptionButton.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClickOption: PropTypes.func.isRequired,
};

export default AttachmentOptionButton;
